import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitolavasacab() {



const cardData = {
  keyword: "Mumbai to Lavasa Cab",

headingDescription:
  "Omshree Cab offers safe and comfortable Mumbai to Lavasa cab services for travelers seeking a serene hill city getaway. Whether you are planning a weekend trip, family vacation, romantic outing, or corporate retreat, our cab service ensures a smooth and hassle-free journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in hill driving and highway routes, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Lavasa cab services.",

topPlaces: [
  {
    title: "Lavasa Lake",
    description:
      "Lavasa Lake is the centerpiece of the hill city, surrounded by lush greenery and modern architecture. Visitors can enjoy leisurely walks, boating, and photography along the scenic promenade. Traveling by cab ensures a comfortable journey from Mumbai, allowing ample time to relax by the lake and explore nearby cafes and walking trails without worrying about transport."
  },
  {
    title: "Dasve Hills",
    description:
      "Dasve Hills offer panoramic views of Lavasa and the surrounding Western Ghats. Visitors can trek, take photographs, and enjoy nature walks in a tranquil environment. Using a cab provides easy and comfortable access, enabling travelers to spend more time enjoying the vistas and less time on logistics."
  },
  {
    title: "Eureka Towers Viewpoint",
    description:
      "Eureka Towers Viewpoint is a scenic spot in Lavasa offering stunning views of the cityscape, hills, and lake. Visitors can enjoy photography, peaceful walks, and relaxation. A cab service allows convenient travel from Mumbai and flexibility in planning sightseeing throughout Lavasa."
  },
  {
    title: "Lavasa Promenade",
    description:
      "Lavasa Promenade is lined with cafes, shops, and walking paths, making it a popular spot for tourists to relax, dine, and enjoy views of the lake. Traveling by cab ensures hassle-free access, giving visitors the freedom to explore at their own pace while experiencing the vibrant atmosphere."
  },
  {
    title: "Mushroom Rocks & Nature Trails",
    description:
      "The Mushroom Rocks and surrounding nature trails in Lavasa provide unique rock formations, scenic walking paths, and opportunities for photography and adventure. A cab ride from Mumbai ensures comfortable travel to these locations, allowing travelers to explore natural beauty efficiently along with other Lavasa attractions."
  },
  {
    title: "Adventure Activities Zone",
    description:
      "Lavasa offers adventure activities like zip-lining, kayaking, and cycling, catering to thrill-seekers and families. Visitors can spend the day enjoying outdoor fun in a safe environment. Traveling by cab allows visitors to reach these zones comfortably and integrate adventure experiences into a full day’s itinerary."
  },
  {
    title: "Sunset Point",
    description:
      "Sunset Point in Lavasa provides breathtaking views of the sun setting over the hills and lake. Visitors can enjoy photography, peaceful reflection, and nature walks. A cab service ensures timely arrival, enabling travelers to capture the perfect sunset and explore other nearby attractions without transport concerns."
  },
  {
    title: "Lavasa Waterfront Dining",
    description:
      "Lavasa offers several waterfront cafes and restaurants where visitors can enjoy meals with scenic lake views. A cab ride ensures comfortable access, allowing tourists to plan dining and sightseeing seamlessly in one trip."
  },
  {
    title: "Hilltop Viewpoints",
    description:
      "Lavasa’s hilltop viewpoints offer panoramic vistas of the Western Ghats, lake, and cityscape. Visitors can trek or drive to these points for photography and nature appreciation. Using a cab provides ease of travel, making it possible to cover multiple viewpoints efficiently."
  },
  {
    title: "Bamboosa Garden",
    description:
      "Bamboosa Garden is a serene garden area in Lavasa featuring bamboo groves, walking paths, and tranquil spots for relaxation. A cab service ensures easy access from Mumbai, allowing visitors to enjoy a calm retreat amidst nature along with other sightseeing experiences in Lavasa."
  }
],




services: [
{
name: "Mumbai to Lavasa Cab",
description: "Mumbai to Lavasa cab service provides comfortable travel from Mumbai to the scenic hill city of Lavasa. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys. Professional drivers with experience on ghat and hill routes ensure safe and timely travel. Pickup is available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for weekend getaways, family vacations, and corporate trips. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options make trip planning convenient. Transparent pricing and reliable service ensure a smooth cab booking experience."
},
{
name: "Mumbai to Lavasa Taxi",
description: "Mumbai to Lavasa taxi service offers convenient and reliable transportation for travelers visiting the beautiful hill destination of Lavasa. Comfortable AC vehicles ensure smooth highway travel and pleasant long-distance journeys. Experienced drivers provide safe driving and ensure timely arrival at the destination. Pickup is available from homes, offices, hotels, and Mumbai airport terminals. Ideal for couples, families, and tourists planning hill station trips. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure scheduling helps passengers plan trips easily. Reliable taxi service ensures safe and comfortable travel."
},
{
name: "Mumbai to Lavasa Cab Service",
description: "Mumbai to Lavasa cab service provides dependable intercity transportation for passengers traveling between Mumbai and Lavasa. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Professional drivers with route knowledge ensure safe driving along scenic hill routes. Pickup services are available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for family vacations, tourist travel, and weekend road trips. Spacious vehicles provide comfortable seating for long journeys. Flexible booking options allow travelers to schedule trips conveniently. Transparent pricing ensures a reliable and trustworthy cab service."
},
{
name: "Mumbai to Lavasa Taxi Service",
description: "Mumbai to Lavasa taxi service offers reliable road travel for passengers visiting the picturesque hill city of Lavasa. Comfortable AC vehicles ensure relaxed travel throughout the highway journey. Experienced drivers guarantee safe driving and punctual arrival at the destination. Pickup services are available from homes, offices, hotels, and airports across Mumbai. Ideal for couples, tourists, and families planning leisure trips. Spacious seating ensures comfortable travel for passengers. Flexible booking options allow convenient travel scheduling. Affordable fares ensure a smooth and enjoyable taxi travel experience."
},
{
name: "Cab from Mumbai to Lavasa",
description: "Cab from Mumbai to Lavasa offers private and comfortable travel for passengers heading to this popular hill destination. Our AC vehicles provide smooth highway journeys and pleasant travel conditions. Professional drivers ensure safe driving through scenic ghat roads. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for sightseeing trips, family vacations, and weekend getaways. Spacious interiors ensure comfortable seating during long journeys. Flexible travel timing allows convenient trip planning. Reliable cab services ensure safe and stress-free travel."
},
{
name: "Taxi from Mumbai to Lavasa",
description: "Taxi from Mumbai to Lavasa provides dependable transportation for travelers seeking comfortable road travel. Our AC vehicles ensure pleasant journeys across highways and hill routes. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup is available from homes, offices, hotels, and airports across Mumbai. Ideal for families, tourists, and corporate travelers. Spacious seating and clean interiors provide relaxed travel conditions. Flexible scheduling options allow passengers to plan trips conveniently. Professional taxi service ensures reliable intercity travel."
},
{
name: "Mumbai to Lavasa Cab Booking",
description: "Mumbai to Lavasa cab booking allows travelers to reserve vehicles easily for hill station trips. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure safe driving and punctual pickup. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Lavasa for sightseeing and vacations. Flexible one-way and round-trip booking options are available. Reliable cab booking ensures hassle-free travel planning."
},
{
name: "Mumbai to Lavasa Taxi Booking Online",
description: "Mumbai to Lavasa taxi booking online offers quick and convenient reservation for passengers planning hill station travel. Instant booking confirmation helps travelers schedule trips easily. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers provide safe and professional driving services. Pickup is available from homes, hotels, offices, and airports across Mumbai. Ideal for tourists, families, and business travelers. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth and stress-free taxi reservations."
},
{
name: "Mumbai to Lavasa Cab Price",
description: "Mumbai to Lavasa cab price offers affordable and transparent travel options for passengers visiting the hill city. Clear pricing details allow travelers to understand travel costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly pricing ensures convenient and reliable cab travel."
},
{
name: "Mumbai to Lavasa Taxi Fare",
description: "Mumbai to Lavasa taxi fare is calculated with transparent per-kilometer pricing to ensure clear travel costs. Passengers can choose vehicle options based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel and pleasant journeys. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for family trips and tourist travel. Flexible booking options allow convenient trip planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Lavasa One Way Cab",
description: "Mumbai to Lavasa one way cab service is perfect for travelers who require a drop service without return charges. This option helps reduce travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance travel. Professional drivers ensure safe driving through highway and ghat sections. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Lavasa for short trips. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable and comfortable travel."
},
{
name: "Mumbai to Lavasa Round Trip Taxi",
description: "Mumbai to Lavasa round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return timing allows travelers to explore Lavasa comfortably. Comfortable AC vehicles ensure relaxed travel during long-distance journeys. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for weekend vacations, sightseeing trips, and family tours. Spacious vehicles ensure comfortable travel for groups. Reliable round-trip taxi service ensures smooth travel planning."
},
{
name: "Mumbai to Lavasa Innova Cab",
description: "Mumbai to Lavasa Innova cab service provides spacious and comfortable travel for families and group travelers. The premium MPV offers ample seating space and luggage capacity for hill station trips. AC interiors ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe highway and ghat road driving. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for family vacations and group sightseeing tours. Comfortable seating ensures relaxed travel for passengers. Reliable Innova cab service ensures convenient hill station travel."
},
{
name: "Mumbai to Lavasa Sedan Cab",
description: "Mumbai to Lavasa sedan cab service offers an affordable and comfortable travel option for individuals and small families. Sedans provide smooth highway performance and relaxed seating. AC interiors ensure pleasant travel conditions throughout the journey. Professional drivers ensure safe and punctual travel between Mumbai and Lavasa. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, tourist visits, and weekend trips. Flexible booking options allow convenient scheduling. Reliable sedan cab service ensures economical and comfortable travel."
}
],

tableData: [
["Mumbai to Lavasa Cab","Mumbai to Lavasa Taxi"],
["Mumbai to Lavasa Cab Service","Mumbai to Lavasa Taxi Service"],
["Cab from Mumbai to Lavasa","Taxi from Mumbai to Lavasa"],
["Mumbai to Lavasa Cab Booking","Mumbai to Lavasa Taxi Booking Online"],
["Mumbai to Lavasa Cab Price","Mumbai to Lavasa Taxi Fare"],
["Mumbai to Lavasa One Way Cab","Mumbai to Lavasa Round Trip Taxi"],
["Mumbai to Lavasa Innova Cab","Mumbai to Lavasa Sedan Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving on the scenic hill roads connecting Mumbai to Lavasa. They understand the curves, elevation changes, and traffic patterns of the Western Ghats, ensuring a safe and smooth journey to this beautiful hill city."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Lavasa cab bookings. We clearly explain per-kilometer rates, toll charges, and package costs before confirmation so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you are planning a morning hill station trip or a late-night return from Lavasa, Omshree Cabs provides round-the-clock cab booking and customer support for your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, fully air-conditioned vehicles designed for long-distance and hill travel. Each car is cleaned and sanitized regularly to ensure a comfortable and hygienic journey."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible trip options including one-way cabs, round trips, and same-day return packages. Travelers can customize their travel plan according to their schedule and sightseeing preferences."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles for couples, families, or group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Lavasa begins smoothly and comfortably."
  },
  {
    WhyChooseheading: "Reliable Hill Station Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Lavasa trips. Our punctual service, professional drivers, and comfortable vehicles make your hill station travel relaxing and stress-free."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Lavasa by cab?", answer: "The distance from Mumbai to Lavasa is approximately 190 km and the journey usually takes around 4–5 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Lavasa cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Lavasa." },
  { question: "Which vehicles are available for Mumbai to Lavasa travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and travel comfort." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Lavasa cab bookings." },
  { question: "Can we do sightseeing in Lavasa during the trip?", answer: "Yes, travelers can explore attractions like Lavasa Lake Promenade, scenic viewpoints, cycling paths, and nearby hill spots." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return packages?", answer: "Yes, same-day return cab packages from Mumbai to Lavasa are available." },
  { question: "Can we stop during the journey for photos or food?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or scenic photo points." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday seasons when Lavasa receives many tourists." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Shah",
    feedback:
      "Booked Omshree Cabs for a Mumbai to Lavasa trip. The driver handled the hill roads very well and the car was clean and comfortable. Great travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback:
      "Our family trip to Lavasa with Omshree Cabs was wonderful. On-time pickup, smooth driving, and transparent pricing made the journey very enjoyable.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lavasa Cab",
  "description": "Book Mumbai to Lavasa Cab with Omshree Cab for comfortable hill station travel. Reliable taxi service from Mumbai to Lavasa with Innova, Sedan, and other cabs for one-way or round trips. Affordable fares, easy online booking, and safe travel for your Lavasa trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2000"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Lavasa Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Lavasa Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Lavasa with Innova, Sedan, and other cabs for one-way or round trips. Affordable fares and easy online cab booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitolavasacab;